import React from "react";
import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
    wraper:{
        width: 200,
        height: 'auto',
        textAlign:'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection:'column'
    },
    root: {
        width: 150,
        height: 150,
        borderRadius: '50%',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 10,
    },
    circle: {
        width: '92%',
        height: '92%',
        borderRadius: '50%',
        zIndex: 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    },
    gridRectangle: {
        width: '50%',
        height: '50%',
        position: 'absolute',
        top: '50%',
        left: '17%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1,
    },
    rectangle: {
        width: '100%',
        height: '100%',
        transform: 'rotate(-45deg)',
        zIndex: 1,
    },
    text: {
        marginBottom: 0,
        fontSize: 12
    },
    content: {
        lineHeight: 2,
        '& h3': {
            marginTop: 30,
            fontSize: 20,
            fontWeight: "bold",
            marginBottom: 10,
        },
        '& p': {
            fontSize: 13,
            textAlign: 'justify',
            margin: 0,
            padding: 0,
            border: 0,
            font: "inherit",
            verticalAlign: "baseline",
            color: 'rgb(66, 71, 77)',
            '& a': {
                color: 'blue !important',
                padding: '0px 5px'
            }
        },
        '& ul': {
            textAlign: 'justify',
            margin: 0,
            padding: 0,
            border: 0,
           
        },
    },
}));

export default function Index({ item  , className}) {

    const classes = useStyles()

    return (
        <div className={`${classes['wraper']} ${className}`}>

            <div className={classes['root']}
                style={{
                    backgroundColor: item?.colors?.rectangle,
                    marginRight: !item?.visibaleRectangle ? 30 : 10
                }}
            >
                <div className={classes['circle']}
                    style={{ backgroundColor: item?.colors?.circle }}
                >
                    {
                        item?.text?.step && (
                            <p className={classes['text']}>
                                {
                                    item?.data?.step
                                }
                            </p>
                        )
                    }
                    <p className={classes['text']}>
                        {
                            item?.data?.title
                        }
                    </p>
                </div>
                {
                    !item?.visibaleRectangle && (
                        <div className={classes['gridRectangle']}>
                            <div className={classes['rectangle']}
                                style={{ backgroundColor: item?.colors?.rectangle }}
                            >
                            </div>
                        </div>
                    )
                }
            </div>
            <div className={classes['content']}>
                <ul className={classes['list']}>
                    {
                        item?.data?.list?.map((value, ind) => {
                            return (
                                <li key={ind}>
                                    <p>
                                        {value}
                                    </p>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </div>
    );
}

